import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    activedNum:'1'
  },
  // 更改store的状态
  mutations: {
    edit(state,num){
      state.activedNum = num
    }
  },
  strict: process.env.NODE_ENV !== 'production',
})
